import { Resource, MutateShape, SchemaDetail } from "rest-hooks";
import TokenResource from "./TokenResource";

export interface ILoginResource {
	isAuthenticated: boolean;
}

export default class LoginResource
	extends TokenResource
	implements ILoginResource {
	readonly isAuthenticated: boolean = false;
	readonly hasAdminAccess: boolean = false;
	token = "";

	pk() {
		return "login";
	}

	static url() {
		return `${this.urlRoot}loginStatus`;
	}

	static statusShape<T extends typeof Resource>(this: T) {
		const fetch = async (params: Readonly<Record<string, string | number>>) => {
			const response = await this.fetch("get", this.url(params));
			return {
				isAuthenticated: await response.isAuthenticated
			};
		};
		return {
			...super.detailShape(),
			fetch,
		};
	}

	static logoutShape(
		this: typeof LoginResource
	): MutateShape<SchemaDetail<LoginResource>, object, object> {
		return {
			...super.createShape(),
			fetch: (params, body) =>
				this.fetch("post", `${this.urlRoot}Logout`, body),
		};
	}

	/** will suspend when data is stale even if it already exists in cache */
	static getRequestOptions() {
		return {
			invalidIfStale: true,
		};
	}

	static impersonateShape(
		this: typeof LoginResource
	): MutateShape<SchemaDetail<LoginResource>, object, object> {
		return {
			...super.createShape(),
			fetch: (params, body) =>
				this.fetch("post", `${this.urlRoot}impersonate`, body),
		};
	}

	static urlRoot = "/api/login/";
}
